module.exports = __webpack_public_path__ + "img/dangwu.be0d9a73.png";